class AtualizacaoCertificado {
    constructor(modal, pathService) {
        this.modal = modal
        this.pathService = pathService
        this.importado = false
    }

    async enviarCertificado() {
        let {empresa_id, razao_social, raiz_cnpj} = this.certificado
        let modal = this.modal.open({
            backdrop: 'static',
            keyboard: false,
            component: 'envioCertificado',
            resolve: {
                contrato: () => ({id: empresa_id, razaoSocial: razao_social, raizCnpj: raiz_cnpj})
            }
        })

        let result = await modal.result

        if (result && result.ok)
            this.importado = true
    }
}

angular.module('eficienciaFiscalModule')
    .component('atualizacaoCertificado', {
        controller: ["$uibModal", "pathService", AtualizacaoCertificado],
        bindings: {
            certificado: '<'
        },
        template: `
            <div style="display: flex; align-items: center"
                 ng-class="{'text-success': $ctrl.importado}" class="well well-light clearfix">
                <div>
                    {{$ctrl.certificado.razao_social}}
                    <br/>
                    <small class="text-muted">
                        Raiz do CNPJ: {{$ctrl.certificado.raiz_cnpj | cpfCnpj }}
                        | Validade: {{$ctrl.certificado.validade | date:"mediumDate"}}
                        <ng-pluralize ng-if="$ctrl.certificado.dias_ate_vencer < 0"
                                      count="$ctrl.certificado.dias_ate_vencer * -1"
                                      when="{'one': '(venceu ontem)',
                                             'other': '(venceu há {} dias)'}"></ng-pluralize>
                        <ng-pluralize ng-if="$ctrl.certificado.dias_ate_vencer >= 0"
                                      count="$ctrl.certificado.dias_ate_vencer"
                                      when="{'0': '(vence hoje)',
                                             'one': '(vence amanhã)',
                                             'other': '(vence em {} dias)'}"></ng-pluralize>
                    </small>
                </div>
                <div style="width: 183px; margin-left: auto; text-align: center">
                    <a href="javascript:void(0)" ng-if="!$ctrl.importado" 
                       class="btn btn-primary" ng-click="$ctrl.enviarCertificado(certificado)">
                        Enviar novo certificado A1
                    </a>
                    <i class="fa fa-check fa-2x" ng-if="$ctrl.importado"></i>
                </div>
            </div>
        `
    })
